import type { ApprovalAction, ApprovalType } from 'ui-product-approvals-common';

export const APP_GOVERNANCE_APPROVAL_TYPE: ApprovalType = 'CONNECTED_APP';
export const APP_GOVERNANCE_APPROVAL_ACTION: ApprovalAction = 'INSTALL';
export const APP_GOVERNANCE_APPROVAL_TYPE_ID = '0-620';
